<template>
  <router-view />
</template>

<script>
import { useTitle } from '@vueuse/core'

const title = useTitle();

export default {
    watch: {
    $route() {
      if (!this.$route.meta.pageTitle) title.value = 'Login | Web Farm'
      else title.value = `${this.$route.meta.pageTitle} | Web Farm`
    },
  },

}
</script>

<style>

</style>